import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly _isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isLoading$: Observable<boolean> = this._isLoading.asObservable();

  private readonly requests$ = new BehaviorSubject<number>(0);

  constructor() {
    this.requests$.pipe(takeUntilDestroyed()).subscribe((x) => {
      if (x > 0) {
        this._isLoading.next(true);
      } else {
        this._isLoading.next(false);
      }
    });
  }

  addRequest() {
    this.requests$.next(this.requests$.getValue() + 1);
  }

  removeRequest() {
    this.requests$.next(this.requests$.getValue() - 1);
  }

  show() {
    this._isLoading.next(true);
  }

  hide() {
    this._isLoading.next(false);
  }
}
